import { render, staticRenderFns } from "./Comparativa.vue?vue&type=template&id=46fc0d3e&scoped=true&"
import script from "./Comparativa.vue?vue&type=script&lang=js&"
export * from "./Comparativa.vue?vue&type=script&lang=js&"
import style0 from "./Comparativa.vue?vue&type=style&index=0&id=46fc0d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc0d3e",
  null
  
)

export default component.exports